import $ from 'jquery';
import Cookies from 'js-cookie';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';
import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

window.lazySizes = lazySizes;
window.jQuery = $;
window.$ = $;
window.Cookies = Cookies;
window.Splide = Splide;